import React from 'react';
import VerificationCodeInput from '../../../../lib/VerificationCodeInput/VerificationCodeInput';
import { Button } from '../../../../flayr-components/Button/Button';

interface ICodeInputProps {
  value?: string;
  autoFocus?: boolean;
  codeResent?: boolean;
  onChange?: (e: any) => void;
  onComplete?: (e: any) => void;
  onResendCode?: (e: any) => void;
}

const CodeInput: React.FC<React.PropsWithChildren<React.PropsWithChildren<ICodeInputProps>>> = ({
  value,
  onChange,
  autoFocus,
  onComplete,
  onResendCode,
  codeResent,
}) => {
  function handleChange(value) {
    return onChange?.({ target: { name: 'code', value } });
  }
  return (
    <div className="grid max-w-md gap-6 mx-auto text-gray-700">
      <VerificationCodeInput
        autoFocus={autoFocus}
        onChange={handleChange}
        onComplete={onComplete}
        value={value}
      />

      <div className="">
        <Button clear color="secondary" onClick={onResendCode}>
          {(codeResent && 'Code Resent. Send again.') || 'Resend code'}
        </Button>
      </div>
    </div>
  );
};
export default CodeInput;
